/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_CAMPUS = '[Campus] Get Campus',
  GET_CAMPUS_SUCCESS = '[Campus] Get Campus Success',
  GET_CAMPUS_FAILED = '[Campus] Get Campus Failed',

  CREATE_CAMPUS = '[Campus] Create Campus',
  CREATE_CAMPUS_SUCCESS = '[Campus] Create Campus Success',
  CREATE_CAMPUS_FAILED = '[Campus] Create Campus Failed',

  UPDATE_CAMPUS = '[Campus] Update Campus',
  UPDATE_CAMPUS_SUCCESS = '[Campus] Update Campus Success',
  UPDATE_CAMPUS_FAILED = '[Campus] Update Campus Failed',

  GET_BUILDINGS = '[Campus] Get Buildings',
  GET_BUILDINGS_SUCCESS = '[Campus] Get Buildings Success',
  GET_BUILDINGS_FAILED = '[Campus] Get Buildings Failed',

  CREATE_BUILDINGS = '[Campus] Create Building',
  CREATE_BUILDINGS_SUCCESS = '[Campus] Create Building Success',
  CREATE_BUILDINGS_FAILED = '[Campus] Create Building Failed',

  UPDATE_BUILDINGS = '[Campus] Update Building',
  UPDATE_BUILDINGS_SUCCESS = '[Campus] Update Building Success',
  UPDATE_BUILDINGS_FAILED = '[Campus] Update Building Failed',

  GET_ROOMS = '[Campus] Get Rooms',
  GET_ROOMS_SUCCESS = '[Campus] Get Rooms Success',
  GET_ROOMS_FAILED = '[Campus] Get Rooms Failed',

  CREATE_ROOMS = '[Campus] Create Rooms',
  CREATE_ROOMS_SUCCESS = '[Campus] Create Rooms Success',
  CREATE_ROOMS_FAILED = '[Campus] Create Rooms Failed',

  UPDATE_ROOMS = '[Campus] Update Rooms',
  UPDATE_ROOMS_SUCCESS = '[Campus] Update Rooms Success',
  UPDATE_ROOMS_FAILED = '[Campus] Update Rooms Failed',

  GET_COLLEGES = '[Campus] Get Colleges',
  GET_COLLEGES_SUCCESS = '[Campus] Get Colleges Success',
  GET_COLLEGES_FAILED = '[Campus] Get Colleges Failed',

  CREATE_COLLEGES = '[Campus] Create Colleges',
  CREATE_COLLEGES_SUCCESS = '[Campus] Create Colleges Success',
  CREATE_COLLEGES_FAILED = '[Campus] Create Colleges Failed',

  UPDATE_COLLEGES = '[Campus] Update Colleges',
  UPDATE_COLLEGES_SUCCESS = '[Campus] Update Colleges Success',
  UPDATE_COLLEGES_FAILED = '[Campus] Update Colleges Failed',

  GET_COURSES = '[Campus] Get Courses',
  GET_COURSES_SUCCESS = '[Campus] Get Courses Success',
  GET_COURSES_FAILED = '[Campus] Get Courses Failed',

  CREATE_COURSES = '[Campus] Create Courses',
  CREATE_COURSES_SUCCESS = '[Campus] Create Courses Success',
  CREATE_COURSES_FAILED = '[Campus] Create Courses Failed',

  UPDATE_COURSES = '[Campus] Update Courses',
  UPDATE_COURSES_SUCCESS = '[Campus] Update Courses Success',
  UPDATE_COURSES_FAILED = '[Campus] Update Courses Failed',

  GET_DEPARTMENTS = '[Campus] Get Departments',
  GET_DEPARTMENTS_SUCCESS = '[Campus] Get Departments Success',
  GET_DEPARTMENTS_FAILED = '[Campus] Get Departments Failed',

  CREATE_DEPARTMENTS = '[Campus] Create Departments',
  CREATE_DEPARTMENTS_SUCCESS = '[Campus] Create Departments Success',
  CREATE_DEPARTMENTS_FAILED = '[Campus] Create Departments Failed',

  UPDATE_DEPARTMENTS = '[Campus] Update Departments',
  UPDATE_DEPARTMENTS_SUCCESS = '[Campus] Update Departments Success',
  UPDATE_DEPARTMENTS_FAILED = '[Campus] Update Departments Failed',
}

// CAMPUS ACTIONS
export const getCampus = createAction(
  ActionTypes.GET_CAMPUS
);

export const getCampusSuccess = createAction(
	ActionTypes.GET_CAMPUS_SUCCESS,
  props<{ data: any }>()
);

export const getCampusFailed = createAction(
  ActionTypes.GET_CAMPUS_FAILED,
  props<{ data: any }>()
);

export const createCampus = createAction(
  ActionTypes.CREATE_CAMPUS,
  props<{ data: any }>()
);

export const createCampusSuccess = createAction(
	ActionTypes.CREATE_CAMPUS_SUCCESS,
  props<{ data: any }>()
);

export const createCampusFailed = createAction(
  ActionTypes.CREATE_CAMPUS_FAILED,
  props<{ data: any }>()
);

export const updateCampus = createAction(
  ActionTypes.UPDATE_CAMPUS,
  props<{ data: any, campusId: any }>()
);

export const updateCampusSuccess = createAction(
	ActionTypes.UPDATE_CAMPUS_SUCCESS,
  props<{ data: any }>()
);

export const updateCampusFailed = createAction(
  ActionTypes.UPDATE_CAMPUS_FAILED,
  props<{ data: any }>()
);

// BUILDING ACTIONS
export const getBuildings = createAction(
  ActionTypes.GET_BUILDINGS
);

export const getBuildingsSuccess = createAction(
	ActionTypes.GET_BUILDINGS_SUCCESS,
  props<{ data: any }>()
);

export const getBuildingsFailed = createAction(
  ActionTypes.GET_BUILDINGS_FAILED,
  props<{ data: any }>()
);

export const createBuilding = createAction(
  ActionTypes.CREATE_BUILDINGS,
  props<{ data: any }>()
);

export const createBuildingSuccess = createAction(
	ActionTypes.CREATE_BUILDINGS_SUCCESS,
  props<{ data: any }>()
);

export const createBuildingFailed = createAction(
  ActionTypes.CREATE_BUILDINGS_FAILED,
  props<{ data: any }>()
);

export const updateBuilding = createAction(
  ActionTypes.UPDATE_BUILDINGS,
  props<{ data: any, buildingId: any }>()
);

export const updateBuildingSuccess = createAction(
	ActionTypes.UPDATE_BUILDINGS_SUCCESS,
  props<{ data: any }>()
);

export const updateBuildingFailed = createAction(
  ActionTypes.UPDATE_BUILDINGS_FAILED,
  props<{ data: any }>()
);

// ROOM ACTIONS
export const getRooms = createAction(
  ActionTypes.GET_ROOMS
);

export const getRoomsSuccess = createAction(
	ActionTypes.GET_ROOMS_SUCCESS,
  props<{ data: any }>()
);

export const getRoomsFailed = createAction(
  ActionTypes.GET_ROOMS_FAILED,
  props<{ data: any }>()
);

export const createRooms = createAction(
  ActionTypes.CREATE_ROOMS,
  props<{ data: any }>()
);

export const createRoomsSuccess = createAction(
	ActionTypes.CREATE_ROOMS_SUCCESS,
  props<{ data: any }>()
);

export const createRoomsFailed = createAction(
  ActionTypes.CREATE_ROOMS_FAILED,
  props<{ data: any }>()
);

export const updateRooms = createAction(
  ActionTypes.UPDATE_ROOMS,
  props<{ data: any, roomId: any }>()
);

export const updateRoomsSuccess = createAction(
	ActionTypes.UPDATE_ROOMS_SUCCESS,
  props<{ data: any }>()
);

export const updateRoomsFailed = createAction(
  ActionTypes.UPDATE_ROOMS_FAILED,
  props<{ data: any }>()
);

// COLLEGE ACTIONS
export const getColleges = createAction(
  ActionTypes.GET_COLLEGES
);

export const getCollegesSuccess = createAction(
	ActionTypes.GET_COLLEGES_SUCCESS,
  props<{ data: any }>()
);

export const getCollegesFailed = createAction(
  ActionTypes.GET_COLLEGES_FAILED,
  props<{ data: any }>()
);

export const createCollege = createAction(
  ActionTypes.CREATE_COLLEGES,
  props<{ data: any }>()
);

export const createCollegeSuccess = createAction(
	ActionTypes.CREATE_COLLEGES_SUCCESS,
  props<{ data: any }>()
);

export const createCollegeFailed = createAction(
  ActionTypes.CREATE_COLLEGES_FAILED,
  props<{ data: any }>()
);

export const updateCollege = createAction(
  ActionTypes.UPDATE_COLLEGES,
  props<{ data: any, collegeId: any }>()
);

export const updateCollegeSuccess = createAction(
	ActionTypes.UPDATE_COLLEGES_SUCCESS,
  props<{ data: any }>()
);

export const updateCollegeFailed = createAction(
  ActionTypes.UPDATE_COLLEGES_FAILED,
  props<{ data: any }>()
);

// COURSES ACTIONS
export const getCourses = createAction(
  ActionTypes.GET_COURSES
);

export const getCoursesSuccess = createAction(
	ActionTypes.GET_COURSES_SUCCESS,
  props<{ data: any }>()
);

export const getCoursesFailed = createAction(
  ActionTypes.GET_COURSES_FAILED,
  props<{ data: any }>()
);

export const createCourses = createAction(
  ActionTypes.CREATE_COURSES,
  props<{ data: any }>()
);

export const createCoursesSuccess = createAction(
	ActionTypes.CREATE_COURSES_SUCCESS,
  props<{ data: any }>()
);

export const createCoursesFailed = createAction(
  ActionTypes.CREATE_COURSES_FAILED,
  props<{ data: any }>()
);

export const updateCourses = createAction(
  ActionTypes.UPDATE_COURSES,
  props<{ data: any, courseId: any }>()
);

export const updateCoursesSuccess = createAction(
	ActionTypes.UPDATE_COURSES_SUCCESS,
  props<{ data: any }>()
);

export const updateCoursesFailed = createAction(
  ActionTypes.UPDATE_COURSES_FAILED,
  props<{ data: any }>()
);

// COURSES ACTIONS
export const getDepartments = createAction(
  ActionTypes.GET_DEPARTMENTS
);

export const getDepartmentsSuccess = createAction(
	ActionTypes.GET_DEPARTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const getDepartmentsFailed = createAction(
  ActionTypes.GET_DEPARTMENTS_FAILED,
  props<{ data: any }>()
);

export const createDepartments = createAction(
  ActionTypes.CREATE_DEPARTMENTS,
  props<{ data: any }>()
);

export const createDepartmentsSuccess = createAction(
	ActionTypes.CREATE_DEPARTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const createDepartmentsFailed = createAction(
  ActionTypes.CREATE_DEPARTMENTS_FAILED,
  props<{ data: any }>()
);

export const updateDepartments = createAction(
  ActionTypes.UPDATE_DEPARTMENTS,
  props<{ data: any, departmentId: any }>()
);

export const updateDepartmentsSuccess = createAction(
	ActionTypes.UPDATE_DEPARTMENTS_SUCCESS,
  props<{ data: any }>()
);

export const updateDepartmentsFailed = createAction(
  ActionTypes.UPDATE_DEPARTMENTS_FAILED,
  props<{ data: any }>()
);